import { HistoryProps } from '../components/History/History';

type AuditLogDetails = Record<string, unknown>;

export default function formatMerchantName(legalName: string, tradingName?: string): string {
    if (!tradingName || tradingName === legalName) {
        return `${legalName} T/A ${legalName}`;
    }

    return `${legalName} T/A ${tradingName}`;
}

export function getDescription(log: HistoryProps['auditLogs'][0]): string | null {
    if (typeof log?.details === 'string') {
        return log.details;
    }

    if (typeof log?.details !== 'object' || log?.details === null) {
        return null;
    }

    const details = log.details as AuditLogDetails;

    if (log?.entity === 'ADD_MERCHANT_APPLICATION' && typeof details.status === 'string') {
        return details.status;
    }

    if (log?.entity === 'SERVICE' && details.deferRenewalMonths) {
        return `DEFER RENEWAL MONTHS ${details.deferRenewalMonths}`;
    }

    return null;
}
